class PolicyReducerActionTypes {}
PolicyReducerActionTypes.FETCH_POLICY_RESPONSE = "FETCH_POLICY_RESPONSE"
PolicyReducerActionTypes.POLICY_LIST_LOADING = "POLICY_LIST_LOADING"
PolicyReducerActionTypes.ROLLBACK_POLICY_PAGE = "ROLLBACK_POLICY_PAGE"
PolicyReducerActionTypes.UPDATE_POLICY_REPORT = "UPDATE_POLICY_REPORT"
PolicyReducerActionTypes.UPDATE_FILTER_POLICY = "UPDATE_FILTER_POLICY"
PolicyReducerActionTypes.CLEAR_POLICY_FILTER = "CLEAR_POLICY_FILTER"
export default PolicyReducerActionTypes
